export default __webpack_public_path__ + "c4a7cfe58670d459a8abd8346396a2a8.svg";